import { del, get, post, put } from "@/utils/axios";

const PATH = "";

export const ERR_OK = 1;

// 算力召回弹窗资格
export function getAiConversionQualification() {
  return post("/api/v1/activity/aiConversion/qualification", {});
}

// 关闭充值弹窗后的新人算力福利
export function getRetentionPopup() {
  return post("/api/v1/activity/retention/popup", {});
}

// ab test
export function getIndexAB(data) {
  return get("/api/v1/ab/index", data);
}

// 首页创作方案：后端返回工具 Map 的 key 列表
export function recommendHomeTools(data = {}) {
  return post("/api/v1/ai/home/tool-recommend", data);
}

// AI 首页运营广告
export function getHomeCampaignImages(data = {}) {
  return get("/api/v1/campaignImage/list", data);
}

// AI 首页任务
const HOME_TASK_ERROR_RESPONSE = {
  status: 500,
  msg: "AI 搜索任务暂时不可用",
  data: {},
};

function requestHomeTask(request) {
  try {
    return Promise.resolve(request()).catch(() => HOME_TASK_ERROR_RESPONSE);
  } catch {
    return Promise.resolve(HOME_TASK_ERROR_RESPONSE);
  }
}

export function createHomeTask(data = {}) {
  return requestHomeTask(() => post("/api/tasks", data));
}

export function getHomeTask(taskId, data = {}) {
  return requestHomeTask(() => get(`/api/tasks/${taskId}`, data));
}

export function stopHomeTask(taskId, data = {}) {
  return requestHomeTask(() => post(`/api/tasks/${taskId}/stop`, data));
}

// AI 首页首次访问状态
export function isfirstvisit(data = {}) {
  return post("/api/firstvisit", data);
}

export const getHomeFirstVisit = isfirstvisit;

// 获取已经过审的loraList
export function getModeList(data) {
  return get("/api/v1/mode/upload/list", data);
}

// 前往自己创建的的服务器
export function routerMyServer() {
  return get("/api/v1/user/serverList");
}

// 0918 新手引导，新增确认当前用户是进入哪一个组 对照组，实验组1，实验组2
export function guideABTest(data = {}) {
  return get("/api/v1/guide/ab");
}

// 2024.09.13 获取底膜的精简接口
export function getTrainingBase() {
  return get("/api/v1/mode/trainingBase");
}

// 2024.08.28 改图
export function sendReWrite(data = {}) {
  return post("/api/v1/work/edit", data);
}
// 上传lora - 上传模型
export function uploadMode(data = {}) {
  return post("/api/v1/mode/upload", data);
}

// 上传lora - 上传模型配置信息
export function getUploadConfig(data = {}) {
  return get("/api/v1/mode/uploadConfig", data);
}

//获取描述词库表单
export function getDescriptorClass(data = {}) {
  return get("/api/v1/descriptorClass", data);
}

//获取二级描述词库
export function getDescriptorClassSubInfo(data = {}) {
  return get("/api/v1/descriptorClassSubInfo", data);
}

//随机获取描述词
export function getthemeDescriptor(data = {}) {
  return get("/api/v1/themeDescriptor", data);
}

//随机获取描述词
export function getThemeDescriptor(data = {}) {
  return get("/api/v1/themeDescriptor", data);
}

///随机获取描述词V3
export function getThemeDescriptorV3(data = {}) {
  return get("/api/v3/imgDescribe", data);
}

//发送自定义消息
export function postChannelMessage(data = {}) {
  return post("/api/v1/channel/message", data);
}

//获取用户信息
export function getUserInfo(data = {}) {
  return get("/api/v1/hx/userInfo", data);
}

//获取oss上传token
export function postUploadToken(data = {}) {
  return get("/api/v1/upload/token", data);
}

//获取图片临时上传链接（传入自定义上传路径，返回带签名的直传URL与图片cdn域名）
export function getImgUploadUrl(data) {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (data[key] != null) formData.append(key, data[key]);
  });
  return post("/api/v1/upload/getImgUploadUrl", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

//获取oss上传token
export function getServiceOssUploadUrl(data = {}) {
  return get("/service/v1/service/oss/upload_url", data);
}

//获取主题分类列表
export function getThemeClassList(data = {}) {
  return get("/api/v2/themeClassInfo", data);
}

//获取所有主题
export function getAllTheme(data = {}) {
  return get("/api/v1/allTheme", data);
}

//提交AI创作
export function postAIWork(data = {}) {
  return post("/api/v1/work", data);
}

//获取所有主题
export function getTrainingMode(data = {}) {
  return get("/api/v1/training/mode", data);
}

//添加训练
export function postModeTraining(data = {}) {
  return post("/api/v1/mode/training", data);
}

//检查训练文件是否合格
export function postModeCheckFile(data = {}) {
  return post("/api/v1/mode/checkFile", data);
}

//编辑训练模型信息
export function putModeTraining(data = {}) {
  return put("/api/v1/mode/training", data);
}

//删除模型
export function delModeTraining(data = {}) {
  return del(`/api/v1/mode/training/${data.mode_id}`, data);
}

//创建新频道
export function postServerChannel(data = {}) {
  return post("/api/v1/server/channel", data);
}

//编辑频道
export function putServerChannel(data = {}) {
  return put("/api/v1/server/channel", data);
}

//删除频道
export function delServerChannel(data = {}) {
  return del(`/api/v1/server/channel/${data.server_id}/${data.channel_id}`, data);
}

//创建房间
export function postCircleServer(data = {}) {
  return post("/api/v1/circle/server", data);
}

//更新房间
export function putCircleServer(data = {}) {
  return put("/api/v1/circle/server", data);
}

//获取房间信息
export function getCircleServer(data = {}) {
  return get(`/api/v1/circle/server`, data);
}

//绘画作品点击
export function postWorkClick(data = {}) {
  return post("/api/v1/work/click", data);
}

//绘画作品点赞或踩
export function postWorkLikeOrTread(data = {}) {
  return post("/api/v1/work/likeOrTread", data);
}

//训练消息点赞
export function postMessageLike(data = {}) {
  return post("/api/v1/message/like", data);
}

//获取邀请码
export function postInviteCode(data = {}) {
  return post("/api/v1/invite/code", data);
}

//获取密码
export function getServerPassword(data = {}) {
  return get("/api/v1/server/password", data);
}

//获取code房间信息
export function getInviteTrigger(data = {}) {
  return get(`/api/v1/invite/trigger/${data.code}`, data);
}

//根据邀请链接 加入频道或者社区
export function postInviteTrigger(data = {}) {
  return post(`/api/v1/invite/trigger/${data.code}`, data);
}

//共创首页
export function postTogetherIndex(data = {}) {
  return post("/api/v1/together/index", data);
}

//灵感首页推荐
export function getInspirationRecommend(data = {}) {
  if (data.keyword) {
    return get("/api/v1/inspiration/search", data);
  } else {
    return get("/api/v1/inspiration/recommend", data);
  }
}

//灵感首页搜素
export function getInspirationSearch(data = {}) {
  return get("/api/v1/inspiration/search", data);
}

//
export function getImageSegmentation(data = {}) {
  return get("/api/v1/work/imageSegmentation", data);
}

//传图给大数据
export function postImageToStores(data = {}) {
    return post("/api/v1/work/storeRes", data);
}

//AI重绘
export function postWorkEdit(data = {}) {
  return post("/api/v1/work/edit", data);
}

//用户进入房间
export function postCircleJoin(data = {}) {
  return post("/api/v1/circle/join", data);
}


// //删除频道
// export function delServerChannel(data = {}) {
//   return del(`/api/v1/server/channel/${data.server_id}/${data.channel_id}`, data);
// }

//移除频道用户
export function delChannelUser(data = {}) {
  return del("/api/v1/channel/user", data);
}

//内容审核接口
export function postContentReview(data = {}) {
  return post("/api/v1/content/review", data);
}

//获取训练信息
export function getTogetherInfo(data = {}) {
  return get(`/api/v1/together/info/${data.trainId}`, data);
}

//获取模型信息
export function getModeInfo(data = {}) {
  return get(`/api/v1/mode/info/${data.modeId}`, data);
}

//获取频道信息
export function getChannelInfoApi(data = {}) {
  return get(`/api/v1/server/channel/${data.channelId}`, data);
}

//获取渠道内用户
export function getChannelUsers(data = {}) {
  return get(`/api/v1/channel/users`, data);
}

//更新频道内用户相关权限与禁言
export function putChannelUsers(data = {}) {
  return put(`/api/v1/channel/users`, data);
}

//更新频道内用户相关权限与禁言
export function delCircleServerUsers(data = {}) {
  return del(`/api/v1/circle/server/users`, data);
}

//获取今日可用绘画次数
export function getDrawingNum(data = {}) {
  return get(`/api/v1/drawing/num`, data);
}

//图片审核接口
export function postAtlasImages(data = {}) {
  return post("/api/v1/atlas/images", data);
}

//创建房间频道分组
export function postServerGroup(data = {}) {
  return post("/api/v1/server/group", data);
}

//更新频道分组
export function putServerGroup(data = {}) {
  return put("/api/v1/server/group", data);
}

//删除频道分组
export function delServerGroup(data = {}) {
  return del("/api/v1/server/group", data);
}


//用户进入频道
export function postChannelJoin(data = {}) {
  return post("/api/v1/channel/join", data);
}

//用户模型列表
export function getTrainingModeForUser(data = {}) {
  return get(`/api/v1/training/modeForUser`, data);
}

//房间频道列表
export function getServerChannelDetail(data = {}) {
  return get(`/api/v1/server/channel`, data);
}


//获取用户房间所属角色
export function getServerRole(data = {}) {
  return get(`/api/v1/server/role`, data);
}

// //AI新手指导
export function getServiceAiBeginnerGuide(data = {}) {
  return get("/activityunion/ai_beginner_guide/index", data);
}

//根据主题ID获取词库分类及描述词
export function getDescriptorClassByThemeId(data = {}) {
  return get("/api/v1/descriptorClassByThemeId", data);
}

//作品信息
export function getWorkInfo(data = {}) {
  return get("/api/v1/work/info", data);
}

// 图片id获取图片信息
export function getImageInfo(id, data) {
  let url = `/api/v1/work/images/${id}`;
  // console.log('getImageInfo', data)
  if(data) {
    return get(url, data);
  }
  return get(url);
}

// 排队任务
export function getQueneWorkList(data = {}) {
  return post("/api/v1/queue/workList", data);
}

// 普通任务转为VIP任务
export function transferToVipTask(data = {}) {
  return post("/api/v1/drawing/changeVipStatus", data);
}

//用户作品-重绘跳转逻辑
export function getWorkUserListRedrawJump(data = {}) {
  return get("/api/v1/work/userList/redrawJump", data);
}

//用户作品-新图片数量
export function getWorkUserListNewImgNum(data = {}) {
  return get("/api/v1/work/userList/newImgNum", data);
}

// vip套餐
export function getVipPackageList(data = {}) {
  return post("/api/v1/vip/package", data);
}

//算力充值套包
export function getTopsPackageList(data = {}) {
  return get("/api/v3/tops/package", data);
}

// 新VIP分组套包
export function getNewVipPackageList(data = {}) {
  return get("/api/v2/vip/package/grouped", data);
}

// 获取用户算力相关
export function getUserTops(data = {}) {
  return post("/api/v1/user/tops", data);
}

// 充值下单
export function createOrder(formData) {
  return post("/payment/do_payment", formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

// 聚合支付分流
export function getUnionRechargeAB(data = {}) {
  return post("/union_recharge_ab/index", data);
}

// 支付结果查询
export function checkPayResult(formData) {
  return post("/pay/check_pay", formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

//下载币兑换算力
export function exchangeTops(data = {}) {
  return post("/api/v3/tops/downloadCoinExchangeTops", data);
}

// 当前模型实验组
export function getSelectModel(data = {}) {
  return get("/api/v1/ab/channel/selectModel", data);
}

// 用户邀请信息
export function getUserInviteInfo(data = {}) {
  return post("/api/v1/activity/getInviteInfo", data);
}

// 发放优惠券
export function giveCoupon(data = {}) {
  return post("/api/v1/activity/giveCoupon", data);
}

// 获取用户可用优惠券
export function getUserCouponList(data = {}) {
  return post("/pay/common/getCouponInfo", data, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  });
}

// 获取频道推荐优秀作品
export function getChannelWorkRecommend({ channelId, page, pageSize, ...rest } = {}) {
  return post("/api/v1/channel/workRecommend", {
    page,
    pageSize,
    channel_id: channelId,
    ...rest
  });
}

// 作品评分统计接口
export function manualScore(data = {}) {
  return post("/api/v1/work/manualScore", data);
}

// 判断服务器或者频道是否开启ai能力 channel_id和server_id传一个就行
export function checkChannelOpenAi(data) {
  return post("/api/v1/server/channelOpenAi", data);
}

// 老用户弹窗
export function getOldUserModalStatus(data = {}) {
  return post("/api/v1/activity/giftTops/popup", data);
}

// 获取用户充值状态
export function getRechargeStatus(data = {}) {
  return get("/api/v4/user/recharge/status", data);
}

// 批量通过图片id获取图片
export function getImageUrlByIDs(data) {
  return post("/api/v4/img/originalUrls", data);
}

// 获取举报理由
export function getReportReason(data = {}) {
  return get("/api/v4/user/suggestion/reportReason", data);
}

// 提交建议
export function suggestionSubmit(data) {
  return post("/api/v4/user/suggestion", data);
}

// AI渲染 - 获取全部数据
export function AiRenderList(data) {
  return get('/api/v1/rendering/works/list', data);
}
// AI改图 - 官方图库
export function AIGallClass(data) {
  return post('/api/v1/edit/config/getGalleryClass', data)
}
// AI改图 -官方图库图片列表
export function AiGetGallImageList(data) {
  return post('/api/v1/edit/config/getGalleryImgList', data)
}
// AI改图 -模型配置
export function getModel(data) {
  return post('/api/v1/edit/config/getModel', data)
}

// AI改图 -获取新用户引导 -
export function getNewUserGuid(data) {
  return post('/api/v1/edit/config/getNewUserGuid', data)
}

// AI改图 -创建改图作品
export function AICreate(data) {
  return post('/api/v1/edit/works/create', data)
}

// AI改图 -作品列表
export function getAIEditWorkList(data = {}) {
  return post('/api/v1/edit/works/list', data)
}

// AI改图 -作品状态轮询
export function getAIEditWorkStatus(data = {}) {
  return post('/api/v1/edit/works/status', data)
}

// AI改图 -获取任务算力
export function AiGetTops(data) {
  return post('/api/v1/edit/works/getTops', data)
}

// AI改图 -图片下载
export function getEditImageInfo(data) {
  return post('/api/v1/edit/works/downloadImg', data)
}


// 获取用户相关权益
// work_type: 工作类型,不传默认权益， 1- 溜溜ai 2- ai 渲染 3-改图 4-彩平图 5-PS 插件
export function getUserBenefit(data) {
  return get('/api/v1/user/benefit', data)
}

// src\views\AIEditV3 - 获取当前任务所需算力
export function getTaskTops(data) {
  return post('/api/v4/work/checkUserTops', data)
}

// 新改图任务所需算力
export function getNewEditTaskTops(data) {
  return post('/api/v1/edit/works/checkUserTops', data)
}
// 渲染任务所需算力
export function getRenderTaskTops(data) {
  return post('/api/v1/rendering/works/checkUserTops', data)
}



// 用户提示词检测（发起任务前校验提示词合法性，work_type: 1-老版本生图改图 3-新版本改图）
export function promptCheck(data) {
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (data[key] != null) formData.append(key, data[key]);
  });
  return post('/api/v1/prompt/check', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}